import {
    FETCH_BROKERAGE_SUCCESS,
    FETCH_BROKERAGE_FAILURE,
    UPDATE_BROKERAGE_FROM_SOCKET
} from '../actions/brokerage';

const initialState = {
    brokerageData: {}
};

const brokerageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BROKERAGE_SUCCESS:
            return {
                ...state,
                brokerageData: action.payload
            };
        case FETCH_BROKERAGE_FAILURE:
            return {
                ...state,
                brokerageData: {}
            };
        case UPDATE_BROKERAGE_FROM_SOCKET:
            return {
                ...state,
                brokerageData: {
                    ...state.brokerageData,
                    ...action.payload,
                    // Mark as updated from socket for debugging
                    lastUpdatedFrom: 'socket',
                    lastUpdatedAt: Date.now()
                }
            };
        default:
            return state;
    }
};

export default brokerageReducer; 